import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { RebalanceStatus } from '@constants/vaults/vault.constants';

const useStyles = makeStyles<{ status: RebalanceStatus }>()(
  (theme, { status }) => ({
    status: {
      ...(status === RebalanceStatus.Fixed && {
        color: theme.secondary.s3,
      }),

      ...(status === RebalanceStatus.Active && {
        color: theme.accent.a1,
      }),

      ...(status === RebalanceStatus.Paused && {
        color: theme.accent.a4,
      }),
    },
    statusTitle: {
      ...dFlex(),
      gap: 4,
    },
  }),
);

export default useStyles;
